import Env from '../base/env';
import Channels from '../base/channels';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class HeaderLogo
{
  constructor()
  {

    this.fnEnableSkinDark = this.enableSkinDark.bind(this)
    this.fnDisableSkinDark = this.disableSkinDark.bind(this)
    Channels.on('skin::add::dark',this.fnEnableSkinDark)
    Channels.on('skin::remove::dark',this.fnDisableSkinDark)
    this.detectContainerPage()
  }

  disableSkinDark()
  {
    // Env.$html.classList.remove('skin-isDark')
  }

  enableSkinDark()
  {
    // console.log('baller');
    // Env.$html.classList.add('skin-isDark')
  }

  detectContainerPage()
  {
    this.detectContainer = ScrollTrigger.create({
      trigger:document.querySelector('.js-container-page'),
      start:'top top+=50px',
      onEnter:()=>{
        this.enableSkinDark()
      },
      onLeaveBack:()=>{
        this.disableSkinDark()
      }
    })
  }

  destroy()
  {
    this.detectContainer.kill()
  }
}
